// {{{ import
import { createEntityAdapter } from '@reduxjs/toolkit';
import trelloApi from '@chronos/api-client/trelloApi';
import { trelloBaseApi, getTrelloHeaders } from './trelloBaseApi';
// }}}

const boardsAdapter = createEntityAdapter();
export const initialBoardsState = boardsAdapter.getInitialState();

const apiWithTag = trelloBaseApi.enhanceEndpoints({ addTagTypes: ['Board'] });
const boardsApi = apiWithTag.injectEndpoints({
  endpoints: (build) => ({
    getBoards: build.query({
      queryFn: async ({ memberId }, { getState }) => {
        const boards = await trelloApi.getMemberBoards({
          params: { memberId },
          headers: getTrelloHeaders({ getState }),
        });
        const normalized = boardsAdapter.setAll(initialBoardsState, boards);
        return { data: normalized };
      },
    }),
    getBoard: build.query({
      async queryFn({ memberId, boardId }, { dispatch, getState }) {
        const { data } = boardsApi.endpoints.getBoards.select({
          memberId,
        })(getState());

        if (data?.entities && data?.entities[boardId]) {
          return { data: data.entities[boardId] };
        }

        const boardData = await trelloApi.getBoard({ params: { boardId } });

        // ToDo: proper realization to await till getBoards finish if request alredy run
        if (data?.entities) {
          dispatch(
            boardsApi.util.updateQueryData(
              'getBoards',
              { memberId },
              (draft) => {
                boardsAdapter.setOne(draft, boardData);
              }
            )
          );
        } else {
          dispatch(
            boardsApi.util.upsertQueryData(
              'getBoards',
              { memberId },
              boardsAdapter.setOne(initialBoardsState, boardData)
            )
          );
        }
        return { data: boardData };
      },
    }),
  }),
  overrideExisting: false,
});
export const { useGetBoardsQuery, useGetBoardQuery } = boardsApi;

export default boardsApi;
